import { React, useContext, useState } from "react"
import { Modal, Row, Button, Col, Form, Input, Card, Space, Flex } from "antd"
import axios from "axios"
import { EnvironmentContext } from "../routes/EnvironmentContext"
import './landing.css'
import { NavLink } from "react-router-dom"
import Typography from "antd/es/typography/Typography"
const { Text, Link } = Typography;
export function PurchaseModal(props) {
    const { openPurchaseModal, setOpenPurchaseModal, selectedProduct } = props
    const { isLocal } = useContext(EnvironmentContext)
    const [showForm, setShowForm] = useState(false)
    const [showMessage, setShowMessage] = useState(false)
    const [loading, setLoading] = useState(false)


    const [form] = Form.useForm()

    const handleProduct = (e) => {
        setLoading(true)
        axios({
            method: 'post',
            url: (() => {
                if (isLocal === true) {
                    return 'http://localhost:8000/create-checkout-session-guest'
                }
                else {
                    return 'api/create-checkout-session-guest'
                }
            })(),
            withCredentials: true,
            data: { selectedProduct: selectedProduct, fillupForm: e.fillupForm }

        }).then((res) => {
            setLoading(false)
            window.location.replace(res.data);
        }).catch((err) => {
            console.error(err)

        })
    }

    const handleCopy = (e) => {
        e.preventDefault();  {/*Prevents user from copying email*/}
    };
    return (
        <Modal
            open={openPurchaseModal}
            onCancel={() => {
                setOpenPurchaseModal(false)
                setShowForm(false)
                setShowMessage(false)

            }}
            footer={null}>
            <Row>
                <Col xxl={12}>
                    <div className={selectedProduct?.class} style={{ width: "auto", minHeight: "80px", borderRadius: "8px", alignContent: "center", justifyItems: "center", color: "white", textAlign: "center" }}>
                        <h1>{selectedProduct?.title}</h1>
                    </div>
                </Col>
                <Col xxl={12} style={{ justifyItems: "end", alignSelf: "end", textAlign: "center" }}>
                    <Row>
                        <Text strong style={{ fontSize: 20 }}>
                            {selectedProduct?.price}.00
                        </Text>
                    </Row>
                    <Row>

                        <Text strong style={{ fontSize: 18 }}>
                            {selectedProduct?.calculations}
                        </Text>
                    </Row>


                </Col>
            </Row>
            <div className="small-space" />
            <Row justify={"space-around"} style={{ justifyContent: "center" }}>
                <Col xxl={12} style={{ padding: "0px 8px" }} onClick={() => {
                    setShowMessage(true)
                    setShowForm(false)
                }
                }>
                    <Button type="primary" block>
                        Buy for myself
                    </Button>
                </Col>
                <Col xxl={12} style={{ padding: "0px 8px" }}>
                    <Button type="default" block onClick={() => {
                        setShowForm(true)
                        setShowMessage(false)
                    }}>
                        Buy for someone else
                    </Button>
                </Col>
            </Row>
    
            {showForm ? (
                <>
                    <div style={{ marginTop: 24 }} />
                    <Text type="secondary">
                        To buy for someone else, complete the payment first. A license key will be emailed to you—share this key with the recipient so they can activate it using their own account to receive their calculations.
                    </Text>
                    <Card title="Purchase Form" style={{ marginTop: 16 }}>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={() => handleProduct({ fillupForm: form.getFieldsValue(), selectedProduct })}>

                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item
                                        label="First Name"
                                        name="firstname"
                                        rules={[{ required: true, message: "Please input your first name!" }]}
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        label="Last Name"
                                        name="lastname"
                                        rules={[{ required: true, message: "Please input your last name!" }]}
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.Item
                                label="Email"
                                name="email"
                                rules={[
                                    {
                                        type: 'email',
                                        message: 'The input is not valid E-mail!',
                                    },
                                    {
                                        required: true,
                                        message: 'Please input your E-mail!',
                                    },
                                ]}
                                labelCol={{
                                    span: 9
                                }}>
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label="Retype Email"
                                name="reEmail"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please confirm your email!',
                                    },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('email') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error('The email that you entered do not match!'));
                                        },
                                    }),
                                ]}
                                labelCol={{
                                    span: 9
                                }}>
                                <Input />
                            </Form.Item>
                            <Form.Item label="Company"
                                name="company"
                                rules={[{ required: true }]}
                                labelCol={{
                                    span: 9
                                }}>
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label="Company Address"
                                name="companyAddress"
                                rules={[{ required: true }]}
                                labelCol={{
                                    span: 9
                                }}>
                                <Input />
                            </Form.Item>

                            <Button type="primary" block htmlType="submit" loading={loading}>
                                Continue to checkout
                            </Button>

                        </Form>
                    </Card>
                </>
            )
                : showMessage && (
                    <>
                        {/* <div className="small-space" /> */}
                        <div style={{ marginTop: 24 }}>
                            <Text type="secondary">
                                You're almost there! <NavLink to="/login">Log in</NavLink> or <NavLink to="/register">register </NavLink> to complete your personal purchase.
                            </Text>
                        </div>
                    </>
                )}
        </Modal>
    )
}